import { Injectable } from '@angular/core';
import { HttpService } from '../services/http-service.service';
import { environment } from './../../../environments/environment';
import { Observable } from 'rxjs';
import { firstValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';


@Injectable({
  providedIn: 'root'
})


export class AuthService {
  isLoggedIn = false;
  userId: any;
  userData: any;
  validUser = false;
  constructor(private httpService: HttpService,private appService:AppService, private http: HttpClient, private router: Router,) {
  }


  // ValidateToken(): Observable<any> {
  //   // return this.httpService.get(environment.ValidateToken, '');
  // }

  setUserData(data: any): any {
    this.userData = data;
  }

  getUserData(): any {
    return this.userData;
  }

  setUserId(userId: any) {
    this.userId = userId;
  }

  getUserID() {
    return this.userId;
  }

  getUserName() {
    return this.userData.userName;
  }

  async loadAuthriseUserRole() {
    
    return await firstValueFrom(this.httpService.get(`${environment.baseUrl}/Login/AuthorizeUserRole`));
    
  }

  //   ValidateToken1(): any {
  //     return this.httpService.post(environment.ValidateToken, '').toPromise()
  // }
  // isAuthenticated(){
  //   return this.isLoggedIn;
  // }

  // async ValidateToken2(): Promise<any> {
  //   await firstValueFrom(this.http.get<boolean>(environment.ValidateToken))
  //   .then((value) => {
  //     console.log(`Result: ` + value);
  //     return true;
  //   })
  //   .catch((error) => {
  //     console.log(`Result: ` + error);
  //     this.router.navigate(['/login-failed']);
  //     return false;
  // })
  // }

  //   ValidateToken3(): Observable<any> {
  //     return this.http.post<any>(environment.ValidateToken, '');
  // }


}
